<script lang="ts">
  import ResetSent from './reset-sent.svelte';
  import ResetStart from './reset-start.svelte';

  let isSent = false;
  let lastSentResetEmail: string | undefined = undefined;
</script>

{#if !isSent}
  <ResetStart bind:lastSentResetEmail on:success={() => (isSent = true)} />
{:else}
  <ResetSent email={lastSentResetEmail} />
{/if}
